import { IconButton } from "@mui/material";
import { useSnackbar } from "notistack";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";

function SnackbarCloseButton({ snackbarKey }) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton sx={{ color: "white" }} onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon />
    </IconButton>
  );
}

export default SnackbarCloseButton;
